<template>
  <div class="modal_mask">
    <div class="pay-dialog-modal">
      <span
        class="iconfont icon-no close_button"
        @click="$emit('close')"
      ></span>
      <div class="pay-dialog-modal-header">
        <div class="avatars">
          <img :src="loginInfo.image_url" alt="" />
        </div>
        <div class="pay-dialog-modal-header-r">
          <p class="user-name">{{ loginInfo.nick_name }}</p>
          <p class="vip-font">开通会员立享9大特权服务，10大授权范围</p>
        </div>
      </div>
      <div class="pay-dialog-modal-main">
        <div class="left-box">
          <div class="left-box-title">企业VIP</div>
          <div class="left-box-ul">
            <li>从1-100的设计分发效率</li>
            <li>海量版权素材商用零风险</li>
            <li>设计协同管理</li>
            <li>营销素材多样性</li>
            <li>营销设计中台</li>
            <li>图文编辑器</li>
            <li>新媒体舆情</li>
            <li>专属一对一客服服务</li>
          </div>
          <div class="ervm-box">
            <img
              class="img"
              src="@/assets/image/common/paydialog/xcx.jpeg"
              alt=""
            />
            <p>
              爱设计小程序<br />
              移动做图更方便
            </p>
          </div>
        </div>
        <div class="right-box">
          <div class="right-box-tab">
            <!--            <div class="right-box-tab-item"></div>-->
            <div class="right-box-tab-item active">
              <p>企业VIP</p>
              <p>企业商用授权</p>
            </div>
          </div>
          <div class="right-box-inner">
            <div
              class="current-version-box"
              :style="
                loginInfo.company_vip_level == 37 ||
                loginInfo.company_vip_level == 38 ||
                loginInfo.company_vip_level == 10 ||
                loginInfo.company_vip_level == ''
                  ? 'border:none;min-height:0;'
                  : ''
              "
            >
              <p
                v-if="
                  (loginInfo.company_vip_level == 7 ||
                    loginInfo.company_vip_level == 8 ||
                    loginInfo.company_vip_level == 9) &&
                  loginInfo.company_vip_level != 37 &&
                  loginInfo.company_vip_level != 38 &&
                  loginInfo.company_vip_level != ''
                "
              >
                您购买的版本已进行升级，续费请购买升级后的版本
              </p>
              <div
                :style="
                  loginInfo.company_vip_level != 7 &&
                  loginInfo.company_vip_level != 8 &&
                  loginInfo.company_vip_level != 9
                    ? 'border: 1px solid #eff0f2;padding-top: 14px;border-radius: 8px;'
                    : ''
                "
                v-if="
                  loginInfo.company_vip_level == 10 ||
                  loginInfo.company_vip_level == 9 ||
                  $parent.currentProduct.tip == '咨询顾问'
                "
              >
                <p style="font-size: 16px; font-weight: 500">企业旗舰版</p>
                <img
                  src="/img/contact_img.ab2a39c7.png"
                  style="width: 151px"
                  alt=""
                />
                <p
                  style="
                    font-size: 12px;
                    font-size: 12px;
                    color: #999999;
                    padding-bottom: 30px;
                  "
                >
                  扫描上方二维码，咨询客服
                </p>
              </div>
              <p
                v-if="
                  loginInfo.company_vip_level != 10 &&
                  loginInfo.company_vip_level != 9 &&
                  $parent.currentProduct.tip != '咨询顾问' &&
                  loginInfo.company_vip_level != 37 &&
                  loginInfo.company_vip_level != 38 &&
                  loginInfo.company_vip_level != ''
                "
              >
                {{ currentProduct.name }}
              </p>
              <h1
                v-if="
                  currentProduct.name !== '企业旗舰版' &&
                  loginInfo.company_vip_level != 10 &&
                  loginInfo.company_vip_level != 9 &&
                  loginInfo.company_vip_level != 37 &&
                  loginInfo.company_vip_level != 38 &&
                  loginInfo.company_vip_level != ''
                "
              >
                {{ currentProduct.price }}{{ currentProduct.price_suffix }}
              </h1>
              <span
                v-if="
                  currentProduct.name !== '企业旗舰版' &&
                  loginInfo.company_vip_level != 10 &&
                  loginInfo.company_vip_level != 9 &&
                  loginInfo.company_vip_level != 37 &&
                  loginInfo.company_vip_level != 38 &&
                  loginInfo.company_vip_level != ''
                "
                @click="isOpen = !isOpen"
                >升级其他版本</span
              >
            </div>
            <div
              v-if="
                currentProduct.name !== '企业旗舰版' &&
                loginInfo.company_vip_level != 10 &&
                loginInfo.company_vip_level != 9
              "
              v-show="isOpen"
              class="product-list"
            >
              <div
                class="product-list-item"
                :class="productItemClass(item)"
                @click="changQrcode(item)"
                v-for="(item, index) in priceList"
                :key="item.name"
              >
                <h3>{{ item.name }}</h3>
                <p>{{ item.desc }}</p>
                <h1>{{ item.price }}{{ item.price_suffix }}</h1>
                <span>原价 {{ item.cost_price }}</span>
                <div class="flag-tag">立减{{ item.discount }}元</div>
              </div>
              <div class="product-list-item">
                <h3>企业旗舰版</h3>
                <h1>提供定制服务</h1>
                <el-button
                  style="width: 101px; height: 28px"
                  class="el-button-text el-button-text--primary"
                  @click="$emit('showPaySuccess')"
                  >咨询顾问</el-button
                >
              </div>
            </div>
            <div
              v-if="currentProduct.name !== '企业旗舰版'"
              class="select-price-wrapper"
              :class="isOpen ? 'small' : 'normal'"
            >
              <vue-qr
                class="price-qrcode"
                :margin="0"
                :auto-color="true"
                :dot-scale="1"
                :text="qrUrl"
              />
              <div class="select-price-wrapper-right">
                <div class="title">实付金额：</div>
                <h1><span>¥</span>{{ currentProduct.price }}</h1>
                <p>
                  <i class="iconfont icon-weixin3"></i
                  ><i class="iconfont icon-zhifubao1"></i
                  ><span>使用微信/支付宝扫码支付</span>
                </p>
              </div>
            </div>
            <div
              style="
                font-size: 14px;
                color: #999999;
                margin-top: 16px;
                margin-left: 13px;
              "
            >
              支付即视为您同意<span
                @click="goGreement"
                style="color: #6681ff; cursor: pointer"
                >《爱设计VIP会员协议》</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Landing } from "@/config/axios/landing";
import { mapState } from "vuex";
import VueQr from "vue-qr";

export default {
  name: "payDialog",
  components: {
    VueQr,
  },
  props: {
    priceList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // current: {
    //   type: Object,
    //   default: function () {
    //     return null;
    //   },
    // },
    pageType: {
      type: Number,
    },
  },
  data() {
    return {
      isOpen: false,
      show: false,
      qrUrl: "",
      out_no: "",
      getWeixinLogin: null,
      currentProduct: {},
    };
  },
  computed: {
    ...mapState(["loginInfo"]),
    type() {
      return Number(this.pageType);
    },
    productItemClass() {
      return function (item) {
        if (item.button_status === 1) {
          return "disabled";
        }
        return item.vip_level === this.currentProduct.vip_level ? "select" : "";
      };
    },
  },
  watch: {
    currentProduct: {
      deep: true,
      handler(val) {
        this.getOrderNo(val.vip_level);
      },
    },
  },
  methods: {
    goGreement() {
      window.location.href = process.env.VUE_APP_BaseHref + "/vip_agreement";
    },
    changQrcode(item) {
      if (item.button_status === 1) return;
      this.currentProduct = item;
    },
    // 获取订单号
    getOrderNo(level) {
      if (this.$parent.currentProduct.tip == "咨询顾问") {
        return;
      }
      Landing.getOrderNo({
        vip_level: level,
        order_type: this.type,
      })
        .then((res) => {
          if (res.status === 1) {
            this.out_no = res.data.out_no;
            this.getPayUrl(res.data.out_no);
            this.getWeixinLogin = setInterval(() => {
              this.getWxResult();
            }, 1000);
            this.currentPrice = res.data.price;
          }
        })
        .catch((err) => {});
    },
    // 获取二维码url
    getPayUrl(no) {
      Landing.getPayUrl({
        out_no: no,
      })
        .then((res) => {
          if (res.status === 1) {
            this.qrUrl = res.data.url;
          }
        })
        .catch((err) => {});
    },
    // 获取订单支付状态
    getWxResult() {
      Landing.getWxResult({
        out_no: this.out_no,
      })
        .then((res) => {
          if (res.status == 1) {
            if (res.data.is_pay == 1) {
              clearInterval(this.getWeixinLogin);
              this.$router.push({
                name: "PaySuccess",
                query: {
                  name: this.currentProduct.name,
                },
              });
            }
          }
        })
        .catch((err) => {});
    },
  },
  async mounted() {
    if (
      this.loginInfo.company_vip_level == 37 ||
      this.loginInfo.company_vip_level == 38 ||
      this.loginInfo.company_vip_level == ""
    ) {
      this.isOpen = true;
    }
    document.body.classList.add("el-popup-parent--hidden");
    document.body.style.paddingRight = "15px";
    await this.$parent.getVipPrice();
    // 赋值初始level
    this.currentProduct = this.$parent.currentProduct;
  },
  destroyed() {
    document.body.classList.remove("el-popup-parent--hidden");
    document.body.style = "";
  },
};
</script>

<style lang="scss" scoped>
.modal_mask {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);

  .pay-dialog-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    width: 800px;
    height: 625px;
    overflow: hidden;

    .close_button {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 26px;
      color: #999;
      cursor: pointer;
      z-index: 9;

      &:hover {
        color: #ffffff;
      }
    }

    .pay-dialog-modal-header {
      display: flex;
      align-items: center;
      width: 100%;
      height: 85px;
      box-sizing: border-box;
      padding-left: 48px;
      background: #000;
      background-image: url("../../assets/image/common/paydialog/vip-box-two.png"),
        -webkit-linear-gradient(180deg, #646470 0%, #3c3c4b 100%) !important;
      background-size: 100% 100%;
      color: #fff !important;

      .avatars {
        width: 60px;
        height: 60px;
        margin-right: 17px;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 60px;
        }
      }

      .pay-dialog-modal-header-r {
        .user-name {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 25px;
          margin-bottom: 7px;
        }

        .vip-font {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }

    .pay-dialog-modal-main {
      width: 100%;
      flex: 1;
      display: flex;
      align-items: center;

      .left-box {
        width: 188px;
        height: 100%;
        padding: 0 19px;
        background: #f3f3f3;

        .left-box-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2f220e;
          line-height: 22px;
          text-align: center;
          padding-bottom: 27px;
          padding-top: 24px;
          border-bottom: 1px dashed #e3e3ef;
        }

        .left-box-ul {
          margin-top: 8px;
          padding-bottom: 30px;
          border-bottom: 1px dashed #e3e3ef;

          li {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #766e64;
            line-height: 17px;
            position: relative;
            margin-top: 16px;
            padding-left: 13px;

            &:before {
              content: "";
              width: 4px;
              height: 4px;
              border-radius: 50%;
              overflow: hidden;
              position: absolute;
              left: 2px;
              top: 7px;
              background: #766e64;
            }
          }
        }

        .ervm-box {
          width: 100%;

          img {
            display: block;
            width: 56px;
            height: 56px;
            background: #ffffff;
            border-radius: 8px;
            overflow: hidden;
            margin: 43px auto 7px;
          }

          p {
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #766e64;
            line-height: 17px;
          }
        }
      }

      .right-box {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: left;

        .right-box-tab {
          width: 100%;
          height: 74px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .right-box-tab-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;

            p:first-child {
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #29292e;
              line-height: 25px;
              margin-bottom: 3px;
            }

            p:nth-child(2) {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9797aa;
              line-height: 20px;
            }

            &.active {
              background: #d3d3db;
            }
          }
        }

        .right-box-inner {
          flex: 1;
          box-sizing: border-box;
          padding-top: 15px;

          .current-version-box {
            position: relative;
            width: 586px;
            min-height: 110px;
            border-radius: 8px;
            border: 1px solid #eff0f2;
            box-sizing: border-box;
            padding-top: 14px;
            margin: 0 auto;
            text-align: center;

            p:first-child {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #29292e;
              line-height: 20px;
              margin-bottom: 7px;
            }

            p:nth-child(2) {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #29292e;
              line-height: 22px;
            }

            h1 {
              font-size: 26px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #e54b4b;
              line-height: 37px;
            }

            span {
              position: absolute;
              bottom: 13px;
              right: 10px;
              cursor: pointer;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #06b4fd;
              line-height: 17px;
            }

            ::v-deep(.el-button-text--primary) {
              margin-top: 9px;
              font-size: 12px;
              border: 1px solid #dfdfdf;
              background-color: transparent;
              color: #3e3e3e;
              padding: 0 15px;

              &:hover {
                background: #d3d3db;
              }
            }
          }

          .product-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 586px;
            height: 128px;
            margin: 20px auto 0;

            .product-list-item {
              position: relative;
              width: 185px;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-radius: 10px;
              border: 1px solid #dedede;
              cursor: pointer;

              h3 {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 25px;
              }

              p {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 17px;
                margin-bottom: 5px;
              }

              h1 {
                font-size: 22px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #e54b4b;
                line-height: 30px;
                margin-top: 2px;
              }

              span {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 17px;
                margin-top: 3px;
                text-decoration: line-through;
              }

              ::v-deep(.el-button-text--primary) {
                margin-top: 9px;
                font-size: 12px;
                border: 1px solid #dfdfdf;
                background-color: transparent;
                color: #3e3e3e;
                padding: 0 15px;

                &:hover {
                  background: #d3d3db;
                }
              }

              .flag-tag {
                position: absolute;
                top: -10px;
                right: 0;
                width: 67px;
                height: 21px;
                background: #e54937;
                border-radius: 0px 4px 0px 4px;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
                line-height: 21px;
                box-sizing: border-box;
                padding-left: 6px;
              }

              &.disabled {
                background: #f2f2f2;
                color: #999999;
                cursor: not-allowed;

                .flag-tag {
                  background: #999999;
                  color: #ffffff;
                }
              }

              &.select {
                background: #d7d7e3;
              }
            }
          }

          .select-price-wrapper {
            width: 586px;
            display: flex;
            align-items: center;
            margin: 14px auto;
            background: #f7f7f7;
            border-radius: 10px;
            box-sizing: border-box;

            .price-qrcode {
              display: block;
            }

            .select-price-wrapper-right {
              box-sizing: border-box;

              .title {
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
              }

              h1 {
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #e54b4b;
              }

              p {
                .iconfont {
                  font-size: 20px;
                  margin-right: 8px;

                  &.icon-weixin3 {
                    color: #00c800;
                  }

                  &.icon-zhifubao1 {
                    color: #06b4fd;
                  }
                }

                span {
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  vertical-align: text-top;
                }
              }
            }

            &.small {
              padding: 11px 13px;

              .price-qrcode {
                width: 98px;
                height: 98px;
                margin-right: 8px;
              }

              .select-price-wrapper-right {
                padding-top: 2px;

                .title {
                  font-size: 14px;
                  line-height: 20px;
                  margin-bottom: 1px;
                }

                h1 {
                  font-size: 34px;
                  line-height: 45px;
                  margin-bottom: 3px;

                  span {
                    font-size: 16px;
                  }
                }

                p {
                  span {
                    font-size: 14px;
                    line-height: 20px;
                  }
                }
              }
            }

            &.normal {
              padding: 16px 24px;

              .price-qrcode {
                width: 140px;
                height: 140px;
                margin-right: 24px;
              }

              .select-price-wrapper-right {
                padding-top: 36px;

                .title {
                  font-size: 16px;
                  line-height: 22px;
                  margin-bottom: 8px;
                }

                h1 {
                  font-size: 36px;
                  line-height: 45px;
                  margin-bottom: 7px;

                  span {
                    font-size: 16px;
                  }
                }

                p {
                  span {
                    font-size: 16px;
                    line-height: 22px;
                    vertical-align: top;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
